<ng-template #toolbarContent>
  @if (toolbarButtonWrapperTemplate) {
    <rt-wysiwyg-toolbar
      [editorView]="editorView"
      [editorHasFocus]="hasFocus"
      [buttonWrapperTemplate]="toolbarButtonWrapperTemplate"
    ></rt-wysiwyg-toolbar>
  } @else {
    <rt-wysiwyg-toolbar [editorView]="editorView" [editorHasFocus]="hasFocus"></rt-wysiwyg-toolbar>
  }
</ng-template>

<div #editor class="editor-container">
  <div [class.visible]="showSpinner" class="spinner-container">
    <rt-spinner variant="small-x"></rt-spinner>
  </div>
</div>
@if (toolbarVisible) {
  <div
    #toolbarContainer
    class="toolbar"
    [class.is-pinned]="toolbarIsPinned()"
    [class.no-shadow]="toolbarNoShadow()"
  >
    <ng-container [ngTemplateOutlet]="toolbarContent"></ng-container>
  </div>
}
@if (toolbarRightVisible) {
  <div class="toolbar">
    <ng-content select="toolbar-right"></ng-content>
  </div>
}
<ng-container *ngTemplateOutlet="footerTmpl; context: { toolbar: toolbarContent }"></ng-container>
